import { render, staticRenderFns } from "./airplanedetails.vue?vue&type=template&id=95ebe9f4&scoped=true&"
import script from "./airplanedetails.vue?vue&type=script&lang=js&"
export * from "./airplanedetails.vue?vue&type=script&lang=js&"
import style0 from "./airplanedetails.vue?vue&type=style&index=0&id=95ebe9f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ebe9f4",
  null
  
)

export default component.exports